import { evaluateCondition } from './evaluateCondition';
import { evaluateStep } from './evaluateStep';
import { getCurrentStep } from './getCurrentStep';

export const getPath = (config, props, direction) => {
  if (!['next', 'back'].includes(direction)) {
    throw new Error(`Unsupported direction ${direction}`);
  }

  let current = getCurrentStep(config, props) || {};
  let stepPath = evaluateStep(direction, current, props);

  current = getCurrentStep(config, props, { pathOverride: stepPath });
  while (current && current.skip && evaluateCondition(current.skip, props)) {
    stepPath = evaluateStep(direction, current, props);
    current = getCurrentStep(config, props, { pathOverride: stepPath });
  }

  if (!stepPath && stepPath !== '') {
    return false;
  }

  return `${props.basePath}/${stepPath}`;
};
